import { initializeApp} from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCP1P7hvM-fLB2KtpfbRy72uRlssb0c45U",
    authDomain: "sharework-823d7.firebaseapp.com",
    projectId: "sharework-823d7",
    storageBucket: "sharework-823d7.appspot.com",
    messagingSenderId: "666211842694",
    appId: "1:666211842694:web:f7ca3f6fb46f0b69de2f07",
    measurementId: "G-MP4S88TEKJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
